var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 105,
    viewBox: "0 0 152 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5918 15.6645L98.9117 28.6845C98.9117 28.6845 100.982 26.0645 109.252 27.2845C113.462 27.8945 117.482 20.9345 111.742 17.0745C96.7817 7.08449 85.8718 9.73446 81.5918 15.6745V15.6645Z",
    fill: "#F875B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6901 76.4041C78.4601 80.2041 83.2501 73.724 81.0501 70.124C76.7101 63.014 78.3101 60.0441 78.3101 60.0441L59.5501 49.1641C55.7901 55.4441 57.6701 66.5541 72.6901 76.4141V76.4041Z",
    fill: "#F875B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0305 42.1641L90.4805 55.0541C90.4805 55.0541 99.3005 68.524 104.801 66.764C108.071 65.714 108.141 59.5841 108.141 59.5841C108.141 59.5841 122.081 60.0741 120.561 53.5641C119.241 47.9141 99.0205 42.2041 99.0205 42.2041V42.1741L99.0305 42.1641Z",
    fill: "#FFDB2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9014 36.1738L84.3613 55.0938L86.9414 57.6238C88.5114 59.1638 90.9814 59.0738 92.4014 57.3938C96.2814 52.7938 99.5614 47.8338 102.081 42.4138C103.011 40.4138 102.051 38.0438 99.9714 37.2938L96.9014 36.1838V36.1738Z",
    fill: "#7A5FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9401 34.004C52.9401 42.294 59.8 49.894 67.39 56.754C73.07 61.824 81.59 61.3141 85.29 55.6741C89.92 49.1941 94.13 42.884 97.67 36.854C101.37 31.244 98.5 23.1341 91.61 19.9141C82.36 15.6041 72.66 12.294 62.74 9.99402C55.98 8.43402 44.71 8.17403 41.27 13.374C37.82 18.604 42.8701 28.3041 46.9501 33.9541V34.014L46.9401 34.004Z",
    fill: "#7A5FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9008 33.9143H46.9608C55.2908 28.7443 62.1108 18.0543 62.6908 10.0143C55.8908 8.4143 44.7007 8.16427 41.2507 13.3643C37.8407 18.5643 42.8108 28.2643 46.9308 33.9143H46.9008Z",
    fill: "#F875B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4509 41.0844C75.184 41.0844 79.0209 37.2474 79.0209 32.5143C79.0209 27.7812 75.184 23.9443 70.4509 23.9443C65.7178 23.9443 61.8809 27.7812 61.8809 32.5143C61.8809 37.2474 65.7178 41.0844 70.4509 41.0844Z",
    fill: "#BB9FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRocket);
export default __webpack_public_path__ + "static/media/card_rocket.2c156386f221217ebd6753bfc87446fa.svg";
export { ForwardRef as ReactComponent };